import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

const STUDIO_IMG =
  "https://images.unsplash.com/photo-1527011046414-4781f1f94f8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxwaG90b2dyYXBoeSUyMHN0dWRpbyUyMGxpZ2h0JTIwc2V0dXB8ZW58MHx8fHwxNzgwNzY4ODY3fDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="px-6 md:px-12 lg:px-24 py-20 md:py-28"
    >
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12 md:gap-10 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease }}
          className="md:col-span-5 relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden bg-secondary">
            <img
              src={STUDIO_IMG}
              alt="Inside the Chic photography studio"
              className="w-full h-full object-cover"
            />
          </div>
          <p className="eyebrow text-muted-foreground mt-4 hidden">
            The Studio · Essex, London, Kent, Suffolk &amp; beyond
          </p>
        </motion.div>

        <div className="md:col-span-7">
          <p className="eyebrow text-muted-foreground mb-6 hidden">About</p>
          <h2 className="font-serif-display tracking-tight leading-[0.95] text-3xl sm:text-4xl md:text-5xl">
            Andy Thomas.
            <br />
            <span className="italic">One of the most decorated</span>
            <br />
            wedding photographers in the world.
          </h2>
          <div className="hairline my-10 max-w-[260px]" />
          <div className="space-y-5 text-foreground/80 leading-relaxed max-w-xl">
            <p>
              Based in Essex with 17 years behind the camera and over 950
              weddings captured under the Chic brand, Andy holds a{" "}
              <em>Fellowship with the SWPP</em>, the highest distinction
              awarded by the Society of Wedding and Portrait Photographers, for
              exceptional technical skill, artistic vision and professional
              excellence.
            </p>
            <p>
              When you book Andy, you&apos;re not just booking a photographer.
              You&apos;re booking someone trusted by the industry&apos;s
              highest authorities to define what great photography looks like.
            </p>
            <p>
              Now joined forces with{" "}
              <a
                href="https://www.weddingvideo.co.uk/post/wedding-video-essex-announces-acquisition-of-chic-photography-as-the-company"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-wve-merge-link"
                className="italic link-underline hover:opacity-70 transition-opacity"
              >
                Wedding Video Essex
              </a>{" "}
              to deliver photography and film as one seamless team.
            </p>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-6 max-w-sm">
            {[
              ["950+", "Weddings"],
              ["17", "Years"],
            ].map(([n, l]) => (
              <div key={l} className="border-t border-border pt-4">
                <p className="font-serif-display text-3xl md:text-4xl tracking-tight">
                  {n}
                </p>
                <p className="eyebrow text-muted-foreground mt-2">{l}</p>
              </div>
            ))}
          </div>

          {/* Honours strip */}
          <div
            data-testid="andy-honours"
            className="mt-12 border-t border-border pt-8"
          >
            <p className="eyebrow text-muted-foreground mb-5">Selected Honours</p>
            <ul className="space-y-3 text-sm md:text-[0.95rem] text-foreground/85 leading-relaxed">
              <li className="flex gap-3">
                <span className="font-serif-display italic text-foreground/55 shrink-0">·</span>
                <span><em>Fellow</em>, Society of Wedding &amp; Portrait Photographers (SWPP)</span>
              </li>
              <li className="flex gap-3">
                <span className="font-serif-display italic text-foreground/55 shrink-0">·</span>
                <span>2× <em>International Wedding Photographer of the Year</em></span>
              </li>
              <li className="flex gap-3">
                <span className="font-serif-display italic text-foreground/55 shrink-0">·</span>
                <span>3× <em>International Portrait Photographer of the Year</em></span>
              </li>
              <li className="flex gap-3">
                <span className="font-serif-display italic text-foreground/55 shrink-0">·</span>
                <span>Top 10 <em>World&apos;s Best Wedding Photographers</em> (2019)</span>
              </li>
              <li className="flex gap-3">
                <span className="font-serif-display italic text-foreground/55 shrink-0">·</span>
                <span>4× <em>East of England Wedding Photographer of the Year</em></span>
              </li>
              <li className="flex gap-3">
                <span className="font-serif-display italic text-foreground/55 shrink-0">·</span>
                <span>International Judge, SWPP</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
